import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined'
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import EjectIcon from '@mui/icons-material/Eject'
import InsertLinkIcon from '@mui/icons-material/InsertLink'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import RecentActorsIcon from '@mui/icons-material/RecentActors'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import SendIcon from '@mui/icons-material/Send'
import { Alert, AlertTitle } from '@mui/material'

import { Chip } from '@nextui-org/chip'

import cn from 'classnames'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../config.json'
import Link from '../common/util/input/Link'
import { getDrop, getPFP, post } from '../helpers/Api'
import MarkDown from '../markdown/MarkDown'
import { Context } from '../waxplorer/Waxplorer'
import { DropAuthDialog } from './DropAuthDialog'
import { DropPaper } from './DropPaper'
import { InstantMintAndSendDialog } from './InstantMintAndSendDialog'
import { PremintToNfthivepacksDialog } from './PremintToNfthivepacksDialog'
import { RemoveAllAssetsDialog } from './RemoveAllAssetsDialog'
import MainButton from '../common/util/input/MainButton'
import { Accordion, AccordionItem } from '@nextui-org/accordion'

export const DropCard = ({
    dropId,
    collection,
    templates,
    name,
    isPfp,
    description,
    maxClaimable,
    numClaimed,
    accountLimit,
    accountLimitCooldown,
    price,
    drop,
    currency,
    startDate,
    endDate,
    handleMaxClaimableUpdate,
    handleShowBuyers,
    handleAccountLimitUpdate,
    handleDropReferralUpdate,
    handlePriceUpdate,
    handleStartEndTimeUpdate,
    handleNameDescriptionUpdate,
    handleDeleteDrop,
    handleCreatePool,
    handleSetPoolReady,
}) => {
    const [collapseIn, setCollapseIn] = useState(false)
    const [removeAssetDialogOpen, setRemoveAssetDialogOpen] = useState(false)
    const [dropAuthDialogOpen, setDropAuthDialogOpen] = useState(false)
    const [isPremint, setIsPremint] = useState(null)
    const [hasPool, setHasPool] = useState(null)
    const [assetsInPool, setAssetsInPool] = useState(null)
    const [poolReady, setPoolReady] = useState(null)
    const [instantMintAndSendDialogOpen, setInstantSendAndMintDialogOpen] =
        useState(false)
    const [
        premintToNfthivepacksDialogOpen,
        setPremintToNfthivepacksDialogOpen,
    ] = useState(false)

    const [isAuthRequired, setIsAuthRequired] = useState(true)

    const toggleCollapse = () => {
        setCollapseIn(!collapseIn)
    }

    const [state] = useContext(Context)

    const getPool = async (dropId, collectionName) => {
        const poolInfoBody = {
            code: 'nfthivedrops',
            index_position: 'primary',
            json: 'true',
            key_type: 'i64',
            limit: 1,
            lower_bound: dropId,
            upper_bound: dropId,
            reverse: 'true',
            scope: collectionName,
            show_payer: 'false',
            table: 'droppools',
            table_key: '',
        }

        const url =
            process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                ? config.testapi + '/v1/chain/get_table_rows'
                : state.api + '/v1/chain/get_table_rows'

        const poolInfoRes = await post(url, poolInfoBody)

        if (
            poolInfoRes &&
            poolInfoRes.status === 200 &&
            poolInfoRes.data &&
            poolInfoRes.data.rows
        ) {
            return poolInfoRes.data.rows[0]
        }
    }

    const loadDrop = async () => {
        const dropData = drop.isPFP
            ? await getPFP(drop.dropId, state)
            : await getDrop(drop.dropId, state)

        if (
            dropData &&
            dropData.assets_to_mint &&
            dropData.assets_to_mint.length > 0 &&
            dropData.assets_to_mint[0].pool_id === 1
        ) {
            setIsPremint(true)
            const pool = await getPool(drop.dropId, drop.collection)
            if (pool) {
                setHasPool(true)
                setAssetsInPool(pool.assets.length)
                setPoolReady(pool.pool_ready === 1)
                drop.assets = pool.assets
            } else {
                setHasPool(false)
                setAssetsInPool(0)
                setPoolReady(false)
            }
        }
    }

    useEffect(() => {
        if (collapseIn) {
            loadDrop()
        }
    }, [collapseIn])

    const OptionButton = ({ text, icon, action, link, color = 'default' }) => (
        <div className="m-1">
            {link ? (
                <>
                    <Link href={link}>
                        <MainButton onClick={() => close()} endContent={icon}>
                            {text}
                        </MainButton>
                    </Link>
                </>
            ) : (
                <>
                    <MainButton
                        onClick={action}
                        endContent={icon}
                        customColor={color}
                    >
                        {text}
                    </MainButton>
                </>
            )}
        </div>
    )

    const getImage = () => {
        let image = ''
        try {
            if (JSON.parse(drop.displayData).preview_img) {
                image =
                    `${config.ipfs}` + JSON.parse(drop.displayData).preview_img
            } else if (templates[0].preview) {
                image = templates[0].preview
            }
        } catch (e) {
            image = ''
        }

        return image
    }

    const { t } = useTranslation('common')

    return (
        <>
            <div className="mx-2 my-2 w-full 2xl:w-2/3">
                <Accordion variant="splitted">
                    <AccordionItem
                        isOpen={toggleCollapse}
                        key="item1"
                        title={
                            <>
                                {' '}
                                <RemoveAllAssetsDialog
                                    open={removeAssetDialogOpen}
                                    setOpen={setRemoveAssetDialogOpen}
                                    drop={drop}
                                />
                                <DropAuthDialog
                                    open={dropAuthDialogOpen}
                                    setOpen={setDropAuthDialogOpen}
                                    drop={drop}
                                    isAuthRequired={isAuthRequired}
                                    setIsAuthRequired={setIsAuthRequired}
                                    isPfp={isPfp}
                                />
                                <InstantMintAndSendDialog
                                    open={instantMintAndSendDialogOpen}
                                    setOpen={setInstantSendAndMintDialogOpen}
                                    drop={drop}
                                />
                                <PremintToNfthivepacksDialog
                                    open={premintToNfthivepacksDialogOpen}
                                    setOpen={setPremintToNfthivepacksDialogOpen}
                                    drop={drop}
                                />
                                <div
                                    className="group  cursor-pointer relative"
                                    onClick={toggleCollapse}
                                >
                                    <div className="w-full h-60">
                                        {getImage() ? (
                                            <img
                                                src={getImage()}
                                                className={cn(
                                                    'w-full h-full object-cover transition-colors blur-[1px]',
                                                    collapseIn
                                                        ? 'grayscale-0 rounded-t-md'
                                                        : 'grayscale rounded-md',
                                                )}
                                            />
                                        ) : null}
                                    </div>
                                    <div
                                        className={cn(
                                            'ml-2 absolute rounded-xl z-100 bottom-2 pl-5 py-3 w-2/3 bg-zinc-700 opacity-85 dark:bg-dark text-primary',
                                        )}
                                    >
                                        <div>Drop {dropId}</div>
                                        <div className="text-xl  font-extrabold">
                                            {name}
                                        </div>
                                        <div className="text-xl">
                                            {isPremint
                                                ? poolReady || numClaimed > 0
                                                    ? assetsInPool === 0
                                                        ? t(
                                                              'drops.premint_drop_sold_out',
                                                          )
                                                        : t(
                                                              'drops.premint_drop_x_of_y_still_available',
                                                              {
                                                                  x: assetsInPool,
                                                                  y: maxClaimable,
                                                              },
                                                          )
                                                    : t(
                                                          'drops.premint_drop_not_ready',
                                                      )
                                                : drop.isPFP
                                                ? t('drops.generative_drop')
                                                : t('drops.standard_drop')}
                                        </div>
                                    </div>
                                    <div className="text-primary absolute z-100 top-2 left-2 bg-darkt rounded-full">
                                        {collapseIn ? (
                                            <ArrowDropDownOutlinedIcon fontSize="large" />
                                        ) : (
                                            <ArrowDropUpOutlinedIcon fontSize="large" />
                                        )}
                                    </div>
                                    {isPremint &&
                                    !poolReady &&
                                    numClaimed === 0 ? (
                                        <div className="absolute z-100 top-2 right-0 px-5 py-3 w-auto text-xl bg-darkt text-red-600">
                                            <ReportProblemOutlinedIcon fontSize="large" />
                                            <span className="font-bold">
                                                {t(
                                                    'drops.drop_not_ready_more_info',
                                                )}
                                            </span>
                                        </div>
                                    ) : null}
                                </div>
                            </>
                        }
                    >
                        {' '}
                        <div className="bg-zinc-600 dark:bg-graphbg rounded-b-md p-4">
                            {isPremint &&
                            !hasPool &&
                            !poolReady &&
                            numClaimed === 0 ? (
                                <Alert severity="warning">
                                    <AlertTitle>
                                        {t('alerts.action_required')}
                                    </AlertTitle>
                                    {t('drops.drop_not_ready_need_pool')}
                                    <OptionButton
                                        text={t('buttons.add_pool')}
                                        icon={<AddCircleOutlineIcon />}
                                        color={'warning'}
                                        action={() => handleCreatePool(dropId)}
                                    />
                                </Alert>
                            ) : null}

                            {isPremint &&
                            hasPool &&
                            assetsInPool >= 0 &&
                            assetsInPool < maxClaimable &&
                            !poolReady &&
                            numClaimed === 0 ? (
                                <Alert severity="warning">
                                    <AlertTitle>
                                        {t('alerts.action_required')}
                                    </AlertTitle>
                                    {t('drops.drop_not_ready_need_assets')}

                                    <OptionButton
                                        text={t('buttons.add_assets')}
                                        icon={<AddCircleOutlineIcon />}
                                        color={'warning'}
                                        link={`/creator/${collection}/dropcreator/${dropId}/assets`}
                                    />
                                </Alert>
                            ) : null}

                            {isPremint &&
                            hasPool &&
                            assetsInPool === maxClaimable * templates.length &&
                            !poolReady &&
                            numClaimed === 0 ? (
                                <Alert severity="warning">
                                    <AlertTitle>
                                        {t('alerts.action_required')}
                                    </AlertTitle>
                                    {t('drops.drop_not_ready_mark_as_finished')}
                                    <OptionButton
                                        text={t('buttons.mark_as_finished')}
                                        icon={<CheckCircleOutlinedIcon />}
                                        color={'warning'}
                                        action={() =>
                                            handleSetPoolReady(dropId)
                                        }
                                    />
                                </Alert>
                            ) : null}

                            <div className="flex flex-wrap justify-center my-4">
                                {templates.map((template) => (
                                    <div className="mx-3">
                                        <Link
                                            href={`/template/${template.templateId}`}
                                        >
                                            {JSON.parse(template.idata).video ||
                                            JSON.parse(template.idata).image ? (
                                                <img
                                                    src={
                                                        JSON.parse(
                                                            template.idata,
                                                        ).video
                                                            ? `https://ipfs.hivebp.io/preview?collection=${collection}&size=320&hash=` +
                                                              JSON.parse(
                                                                  template.idata,
                                                              ).video
                                                            : `https://ipfs.hivebp.io/preview?collection=${collection}&size=320&hash=` +
                                                              JSON.parse(
                                                                  template.idata,
                                                              ).img
                                                    }
                                                    className="h-28 rounded-md shadow-xl border border-paperl hover:border-primary"
                                                />
                                            ) : (
                                                <>
                                                    <Chip
                                                        size="md"
                                                        color="warning"
                                                    >
                                                        {`Template: ${template.templateId}`}{' '}
                                                    </Chip>
                                                </>
                                            )}
                                        </Link>
                                    </div>
                                ))}
                            </div>

                            <div className="flex flex-wrap">
                                <OptionButton
                                    text={t('drops.view_on_site')}
                                    icon={<InsertLinkIcon />}
                                    link={`/drop/${dropId}`}
                                />
                                <OptionButton
                                    text={`${t('drops.max_claimable')}: ${
                                        maxClaimable > 0
                                            ? maxClaimable
                                            : t('drops.infinite')
                                    }`}
                                    icon={<EditIcon />}
                                    action={() =>
                                        handleMaxClaimableUpdate(
                                            drop,
                                            maxClaimable,
                                            !isPremint,
                                        )
                                    }
                                />
                                {numClaimed > 0 ? (
                                    <OptionButton
                                        text={`${t(
                                            'asset.claimed',
                                        )}: ${numClaimed}`}
                                        icon={<PersonSearchIcon />}
                                        action={() => handleShowBuyers(dropId)}
                                    />
                                ) : null}
                                <OptionButton
                                    text={`${t('drops.account_limit')}: ${
                                        accountLimit > 0
                                            ? accountLimit
                                            : t('drops.infinite')
                                    }`}
                                    icon={<EditIcon />}
                                    action={() =>
                                        handleAccountLimitUpdate(
                                            drop,
                                            accountLimit,
                                            accountLimitCooldown,
                                        )
                                    }
                                />
                                <OptionButton
                                    text={`${t('asset.price')}: ${
                                        price > 0
                                            ? price + ' ' + currency
                                            : t('asset.free')
                                    }`}
                                    icon={<EditIcon />}
                                    action={() => {
                                        handlePriceUpdate(drop, price)
                                    }}
                                />
                                <OptionButton
                                    text={
                                        startDate
                                            ? `${t(
                                                  'drops.start_date',
                                              )}: ${new Date(
                                                  startDate * 1000,
                                              ).toLocaleString()}`
                                            : t('drops.no_start_date')
                                    }
                                    icon={<EditIcon />}
                                    action={() => {
                                        handleStartEndTimeUpdate(
                                            drop,
                                            startDate * 1000,
                                            endDate * 1000,
                                        )
                                    }}
                                />
                                <OptionButton
                                    text={
                                        endDate
                                            ? `${t(
                                                  'drops.end_date',
                                              )}: ${new Date(
                                                  endDate * 1000,
                                              ).toLocaleString()}`
                                            : t('drops.no_end_date')
                                    }
                                    icon={<EditIcon />}
                                    action={() => {
                                        handleStartEndTimeUpdate(
                                            drop,
                                            startDate * 1000,
                                            endDate * 1000,
                                        )
                                    }}
                                />
                                <OptionButton
                                    text={t('drops.update_name_description')}
                                    icon={<EditIcon />}
                                    action={() =>
                                        handleNameDescriptionUpdate(
                                            drop,
                                            name,
                                            description,
                                            JSON.parse(drop.displayData)
                                                .preview_img,
                                        )
                                    }
                                />
                                <OptionButton
                                    text={t('drops.edit_referral_fee')}
                                    icon={<EditIcon />}
                                    action={() =>
                                        handleDropReferralUpdate(drop)
                                    }
                                />
                                <OptionButton
                                    text={t('drops.update_user_verification')}
                                    icon={<EditIcon />}
                                    link={`/creator/${collection}/dropcreator/${dropId}/auth`}
                                />
                                {drop.isPFP ? (
                                    <>
                                        <OptionButton
                                            text={t(
                                                'drops.instant_mint_and_send',
                                            )}
                                            icon={<SendIcon />}
                                            action={() =>
                                                setInstantSendAndMintDialogOpen(
                                                    true,
                                                )
                                            }
                                        />
                                        <OptionButton
                                            text={t('drops.premint_to_x', {
                                                x: 'nfthivepacks',
                                            })}
                                            icon={<RecentActorsIcon />}
                                            action={() =>
                                                setPremintToNfthivepacksDialogOpen(
                                                    true,
                                                )
                                            }
                                        />
                                    </>
                                ) : null}
                            </div>

                            {description ? (
                                <DropPaper
                                    title={t('drops.description')}
                                    expandable
                                >
                                    <MarkDown text={description} />
                                </DropPaper>
                            ) : null}
                            <div className="flex felx-wrap mt-3">
                                <OptionButton
                                    text={t('drops.delete_drop')}
                                    icon={<DeleteIcon />}
                                    color={'error'}
                                    action={() => handleDeleteDrop(drop)}
                                />
                                {isPremint ? (
                                    <OptionButton
                                        text={t('drops.remove_all_assets')}
                                        icon={<EjectIcon />}
                                        color="error"
                                        action={() =>
                                            setRemoveAssetDialogOpen(true)
                                        }
                                    />
                                ) : null}
                            </div>
                        </div>
                    </AccordionItem>
                </Accordion>
            </div>
        </>
    )
}

export default DropCard
